import React from 'react';
import classNames from './style.module.scss';

interface StatusProps {
	isActive: boolean;
}

const Status: React.FC<StatusProps> = (props) => {
	const getStatusClassName = (): string => {
		return props.isActive ? classNames.statusActive : classNames.statusInactive;
	};

	return (
		<div className={classNames.status}>
			<i className="bi bi-activity"></i>
			{props.isActive ? 'Active' : 'Inactive'}
			<div className={getStatusClassName()}></div>
		</div>
	);
};

export default Status;
